import { BaseModel, RecursivePartial } from "@models/base";

export class CalendarCounters extends BaseModel {

    total: number = 0;
    upcoming: number = 0;

    constructor(json?: RecursivePartial<CalendarCounters>) {
        super(json);
        this.parseUnreadCounters(json || {});
    }

    parse(json: RecursivePartial<CalendarCounters>): CalendarCounters {
        super.parse(json);
        this.parseUnreadCounters(json);
        return this;
    }

    private parseUnreadCounters(json: RecursivePartial<CalendarCounters>): void {
        CalendarCounters.assignFields<CalendarCounters>(this, json, [
            'total',
            'upcoming',
        ]);
    }
}
